// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.feedclaims.RentalManagerUserFeedClaimsV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserFeedClaimsRequestDto } from '../..';

export const RentalManagerUserFeedClaimsV2WebApiHandler_request_Path = '/api/web/v2/users/feedClaims/request';

/**
 * Create a claim feed listing request
 */
export const RentalManagerUserFeedClaimsV2WebApiHandler_request = (
  postData: UserFeedClaimsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserFeedClaimsRequestDto, void>(
    {
      endpoint: RentalManagerUserFeedClaimsV2WebApiHandler_request_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
